import request from "@/utils/axios";

//  网站SAAS-获取热门行业列表
export function INDUSTRYSHOT(data) {
  return request({
    url: '/api//api/industrybrand/industrysHot',
    method: 'get',
    data
  })
}
//  官网SAAS-搜索行业/品牌
export function CHECKINDUSTRYBRAND(data) {
  return request({
    url: '/api//api/industrybrand/checkIndustryBrand',
    method: 'POST',
    data
  })
}
//  官网-接受cookies隐私协议
export function ACCEPTCOOKIES(data) {
  return request({
    url: '/api//api/users/acceptCookies',
    method: 'GET',
    data
  })
}
//  官网-订阅
export function SUBSCRIBE(data) {
  return request({
    url: '/api/users/subscribe',
    method: 'POST',
    data
  })
}

//  联系我们-获取主题的下拉列表
export function SELECTSUBJECTS(data) {
  return request({
    url: '/api/industrybrand/selectSubjects',
    method: 'get',
    data
  })
}
//  联系我们-数据新增
export function CONCACT(data) {
  return request({
    url: '/api/industrybrand/concact',
    method: 'POST',
    data
  })
}
//  获取登录信息
export function QUERY(data) {
  return request({
      url: '/api/users/query',
      method: 'get',
      data
  })
}

export function PICTURETOUSU(data) {
  return request({
    url: '/api/report/picture/records/add',
    method: 'POST',
    data
  })
}
